import { render } from "./pb-formtemplate.vue?vue&type=template&id=ab7f18c0"
import script from "./pb-formtemplate.vue?vue&type=script&lang=js"
export * from "./pb-formtemplate.vue?vue&type=script&lang=js"

import "./pb-formtemplate.vue?vue&type=style&index=0&id=ab7f18c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__